module.exports = __webpack_public_path__ + "static/media/profile-hand-bottom.033cc06d.svg";